/**
 * Environment Variables
 */
const env = window['LUCID_SPA_CONFIG'];

export const APP_VERSION = env?.APP_VERSION || '';
export const DEPLOYMENT_ENV = env?.REACT_APP_DEPLOYMENT_ENV || 'local';
export const API_MOCK_ENABLED = import.meta.env.VITE_APP_API_MOCK || false;
export const SENTRY_DSN = env?.REACT_APP_SENTRY_DSN || '';
export const AMPLITUDE_KEY = env?.AMPLITUDE_KEY || '';
export const AMPLITUDE_ENABLED = env?.AMPLITUDE_ENABLED || false;

/**
 * Measurement UI base URL by deployment environment
 */
const MEASUREMENT_BASE_URLS: Record<string, string> = {
  local: 'http://localhost:3000',
  'dev-aud': window.location.href.includes('localhost')
    ? 'http://localhost:3000'
    : 'https://im-ui.aud.dev.tech.lucidhq.cloud',
  'prd-prd': 'https://measurement.cint.com'
};

export const MEASUREMENT_BASE_URL =
  MEASUREMENT_BASE_URLS[DEPLOYMENT_ENV] || MEASUREMENT_BASE_URLS['prd-prd'];

/**
 * Routes
 */
export const ROUTES = {
  home: '/',
  logout: '/logout',
  admin: '/impact-measurement/admin',
  im: '/impact-measurement/',
  imAdminCampaigns: '/impact-measurement/admin/campaigns',
  adminCampaign: '/admin/campaign',
  adminCampaigns: '/admin/campaigns',
  appcues: '/appcues-redirect/',
  campaignManager: '/admin/campaign-manager/',
  campaignManagerLanding: '/admin/campaign-manager/new'
};

/**
 * API URLs
 */
export const URLS = {
  API: '/api/v1',
  IM_UI: `${MEASUREMENT_BASE_URL}/studies`
};
